import loadable from '@loadable/component';

import './Help.css';

export default loadable(() => {
  return import('./Help.jsx');
});
